module.exports = __webpack_public_path__ + "a881360c28a4cfcd325603874011028d.jpg";